import {text} from 'shared/icons/index';

export default {
  type: 'editor.elements.TitleElement',
  name: 'Headline',
  editModeTitle: 'Edit Headline',
  icon: text,
  order: 30,
  tooltip: 'These should be used for headings and labels. It is usually a short text.',
};
